/**
 * Created by cc on 2016/9/28 0028.
 */
export default  {
    FLOW_VALID_YES: 0,
    FLOW_VALID_NO: 1,

    NODE_ALLOW_DISCARD_YES: 0,
    NODE_ALLOW_DISCARD_NO: 1,

    NODE_ALLOW_GOBACK_YES: 0,
    NODE_ALLOW_GOBACK_NO: 1,

    NODE_ALLOW_SAVE_YES: 0,
    NODE_ALLOW_SAVE_NO: 1,

    NODE_ALLOW_DEL_YES: 0,
    NODE_ALLOW_DEL_NO: 1,

    NODE_TYPE_START: 0,
    NODE_TYPE_DEAL: 1,
    NODE_TYPE_DRTAFT: 2,
    NODE_TYPE_AUTO: 3,
    NODE_TYPE_END: 9,

    ACTION_TYPE_NORMAL: 0,
    ACTION_TYPE_SAVE: 1,
    ACTION_TYPE_DEL: 2,
    ACTION_TYPE_DISCARD: 99,
    ACTION_TYPE_UN_DISCARD: 98,
    ACTION_TYPE_GOBACK: 9,

    INSTANCE_STATE_NORMAL: 0,
    INSTANCE_STATE_END: 9,
    INSTANCE_STATE_DISCARD: 99,

    NORMAL_EMPTY_STR: '',

    ACTION_SAVE_ID: 'save',
    ACTION_SAVE_CODE: 'save',
    ACTION_DEL_ID: 'del',
    ACTION_DEL_CODE: 'del',
    ACTION_DISCARD_ID: 'discard',
    ACTION_DISCARD_CODE: 'discard',
    ACTION_UN_DISCARD_ID: 'undiscard',
    ACTION_UN_DISCARD_CODE: 'undiscard',
    ACTION_GOBACK_ID: 'goback',
    ACTION_GOBACK_CODE: 'goback'
}
module.exports = exports.default;